import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["link"];

    connect() {
        this.linkTarget.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick(event) {
        $(this.linkTarget).attr("disabled", true);
        $(this.linkTarget).addClass("disabled");
        $(this.linkTarget).html(this.linkTarget.dataset.disableWith);
    }
}
